// mixins/globalMixin.js
import { safeLocalStorage, safeStorageSnapshot } from '@/utils/safeStorage'
import { SINGLE_COUNTRY } from '@/config/singleCountry'

export default {
  data() {
    const storage = safeStorageSnapshot(safeLocalStorage(), [
      'token',
      'currency',
      'platform',
      'currencyUnit',
      'areaCode',
      'iconUrl',
      'countryName',
      'country'
    ])
    return {
      // token 类绝不加单国兜底
      token: storage.token,
      // 单国实例:localStorage 为空时从 SINGLE_COUNTRY 派生兜底(置 null 即回退多国/原始空值)
      getCurrency: storage.currency || (SINGLE_COUNTRY && SINGLE_COUNTRY.currency) || 'XOF',
      GET_PLATFORM: storage.platform || (SINGLE_COUNTRY && SINGLE_COUNTRY.platform),
      GET_CURRENCYUNIT: storage.currencyUnit || (SINGLE_COUNTRY && SINGLE_COUNTRY.currencyUnit) || 'XOF',
      GET_AREACODE: storage.areaCode || (SINGLE_COUNTRY && SINGLE_COUNTRY.areaCode),
      GET_ICONURL: storage.iconUrl,
      GET_COUNTRYNAME: storage.countryName,
      GET_COUNTRY: storage.country
    }
  },
  methods: {},
  created() {}
}
